import React from "react";
import { createBrowserRouter } from "react-router-dom";

import LoginPage from "../pages/auth/login";

import EventListPage from "../pages/event/eventList";

import ProgramAddPage from "../pages/program/programAdd";
import ProgramDetailPage from "../pages/program/programDetail";
import ProgramEditPage from "../pages/program/programEdit";
import ProgramListPage from "../pages/program/programList";

import UserListPage from "../pages/user/userList";

import AnnouncementPage from "../pages/announcement";
import ReportPage from "../pages/report";

import ContactUsPage from "../pages/contactUs";

import DashboardPage from "../pages/dashboard";

import ErrorPage from "../pages/error";

import GuidePage from "../pages/guide";

import InstructionPage from "../pages/instruction";

import ProfilePage from "../pages/profile";

import NotFoundErrorPage from "../pages/notFoundError";

import DispatcherPage from "../pages/dispatcher";
import ProgramDataPage from "../pages/programData";
import StatisticalReports from "../pages/statisticalReports";
import CityList from "../pages/cityList";
import StateList from "../pages/stateList";
import MajmooeList from "../pages/majmooeList";
import SazmanList from "../pages/sazmanList";
import MonasebatList from "../pages/monasebatList";
import HozeFaaliatList from "../pages/hozeFaaliatList";
import BarnameList from "../pages/barnameList";
import OnvanList from "../pages/onvanList";
import Mozoolist from "../pages/mozooList";
import QuestionList from "../pages/questionList";
import MediaAddPage from "../pages/media/mediaAdd";
import MediaListPage from "../pages/media/mediaList";
import MediaEditPage from "../pages/media/mediaEdit";
import MediaDetailPage from "../pages/media/mediaDetail";
import MediaCards from "../pages/media/mediaCards";

const routerConfig = createBrowserRouter([
  {
    path: "/",
    element: <DispatcherPage />,
  },
  {
    path: "/auth",
    errorElement: <ErrorPage />,
    children: [
      {
        path: "login",
        element: <LoginPage />,
      },
    ],
  },
  {
    path: "/event",
    children: [
      {
        path: "list",
        element: <EventListPage />,
      },
    ],
  },
  {
    path: "/program",
    children: [
      {
        path: "add",
        element: <ProgramAddPage />,
      },
      {
        path: "detail/:id",
        element: <ProgramDetailPage />,
      },
      {
        path: "edit/:id",
        element: <ProgramEditPage />,
      },
      {
        path: "list",
        element: <ProgramListPage />,
      },
    ],
  },
  {
    path: "/user",
    children: [
      {
        path: "list",
        element: <UserListPage />,
      },
    ],
  },
  {
    path: "/announcement",
    element: <AnnouncementPage />,
  },
  {
    path: "/report",
    element: <ReportPage />,
  },
  {
    path: "/contactUs",
    element: <ContactUsPage />,
  },
  {
    path: "/dashboard",
    element: <DashboardPage />,
  },
  {
    path: "/guide",
    element: <GuidePage />,
  },
  {
    path: "/instruction",
    element: <InstructionPage />,
  },
  {
    path: "/profile",
    element: <ProfilePage />,
  },
  {
    path: "/programData",
    element: <ProgramDataPage />,
  },
  {
    path: "/statisticalReports",
    element: <StatisticalReports />,
  },
  {
    path: "/cityList",
    element: <CityList />,
  },
  {
    path: "/stateList",
    element: <StateList />,
  },
  {
    path: "/majmooeList",
    element: <MajmooeList />,
  },
  {
    path: "/sazmanList",
    element: <SazmanList />,
  },
  {
    path: "/monasebatList",
    element: <MonasebatList />,
  },
  {
    path: "/hozeFaaliatList",
    element: <HozeFaaliatList />,
  },
  {
    path: "/barnameList",
    element: <BarnameList />,
  },
  {
    path: "/onvanList",
    element: <OnvanList />,
  },
  {
    path: "/mozooList",
    element: <Mozoolist />,
  },
  {
    path: "/questionList",
    element: <QuestionList />,
  },
  // {
  //   path: "/media",
  //   children: [
  //     {
  //       path: "add",
  //       element: <MediaAddPage />,
  //     },
  //     {
  //       path: "edit/:id",
  //       element: <MediaEditPage />,
  //     },
  //     {
  //       path: "detail/:id",
  //       element: <MediaDetailPage />,
  //     },
  //     {
  //       path: "list",
  //       element: <MediaListPage />,
  //     },
  //     {
  //       path: "cards",
  //       element: <MediaCards />,
  //     },
  //   ],
  // },
  {
    path: "*",
    element: <NotFoundErrorPage />,
  },
]);

export default routerConfig;
